import {
  getIntervalName,
  isPlanObject,
} from '@repo/editor/src/components/Subscription';
import {
  SubscriptionPlanType,
  type Subscription,
} from '@repo/subscription/api';
import { pluralSuffix } from '@repo/ui/utils';

/** Get team text for subscription card */
export const getCardTextTeam = (subscription: Subscription | null): string => {
  if (subscription === null || !subscription.activeSeats) {
    return '';
  }
  const { activeSeats } = subscription;

  const {
    name: planName,
    interval,
    quantity: seatsTotal,
  } = subscription?.plan && isPlanObject(subscription.plan)
    ? subscription.plan
    : {
        name: SubscriptionPlanType.FREE,
        interval: undefined,
        quantity: undefined,
      };

  const cardTextsTeam = {
    [SubscriptionPlanType.FREE]:
      'Drag & drop editor to create stunning designs with just a few clicks. Use the template and elements library to work on a limited number of projects. Download JPG & PNG files with up to 800px width.',
    [SubscriptionPlanType.PRO]: `Your team is on a Pro plan (${getIntervalName(
      interval
    )}ly) with ${activeSeats} seat${pluralSuffix(
      activeSeats
    )} (${seatsTotal} allocated).`,
    [SubscriptionPlanType.EXPERT]: `Your team is on an Expert plan (${getIntervalName(
      interval
    )}ly) with ${activeSeats} seat${pluralSuffix(
      activeSeats
    )} (${seatsTotal} allocated).`,
  };

  return cardTextsTeam[planName];
};
